// extracted by mini-css-extract-plugin
module.exports = {"root":"PageTitle_root__bvnLN","wrapper":"PageTitle_wrapper__f7C5O","title":"PageTitle_title__709e6"};